import api from './api.js';

class Dealer {
    constructor(){
        this.url_dealers = 'Dealers';
    }

    all(){
        return api.get(this.url_dealers);
    }

    allDX(){
        return `${api.getBaseUrl()}/${this.url_dealers}`;
    }

    get(id){
        return api.get(`${this.url_dealers}/${id}`);
    }

    update(id, data){
        return api.put(`${this.url_dealers}/${id}`, data);
    }

    salesReps(id){
        return api.get(`${this.url_dealers}/${id}/SalesReps`);
    }

    transferSalesReps(id){
        return api.get(`${this.url_dealers}/${id}/TransferSalesReps`);
    }

    currentUserSubordinates(id){
        return api.get(`${this.url_dealers}/${id}/Subordinates`);
    }

    manufacturers(id){
        return api.get(`${this.url_dealers}/${id}/Manufacturers`);
    }

    salesTax(id){
        return api.get(`${this.url_dealers}/${id}/SalesTax`);
    }

    groups(id){
        return api.get(`${this.url_dealers}/${id}/Groups`);
    }

    customIcons(id){
        return api.get(`${this.url_dealers}/${id}/CustomIcons`);
    }

    uploadAccessDB(file){
        let headers = { 'Content-Type': 'multipart/form-data'};
        let formData = new FormData();
        formData.append('file',file,file.name);
        return api.post(`${this.url_dealers}/OrderExport`, formData, headers);
    }

    uploadTemplate(data){
        let headers = { 'Content-Type': 'multipart/form-data'};
        let formData = new FormData();
        formData.append('file',data.file,data.file.name);
        return api.post(`${this.url_dealers}/${data.id}/Documents`, formData, headers);
    } 
    uploadConfigurator(data){
        let headers = { 'Content-Type': 'multipart/form-data'};
        let formData = new FormData();
        formData.append('file',data.file,data.file.name);
        return api.post(`${this.url_dealers}/Configurators`, formData, headers);
    } 
    configurators(){
        return api.get(`${this.url_dealers}/Configurators`)
    }
    configuratorsProducts(id){
        return api.get(`${this.url_dealers}/Configurators/Members/Categories/${id}/Groups`)
    }
}

export default new Dealer;
